export default __webpack_public_path__ + "Rocket_small.2efe0caa.png";